let BOT_DATA = null;

/* =========================
   LOAD JSON DATA (SHOPIFY SAFE)
========================= */
if (window.SHOPIFY_BOT_DATA_URL) {
  fetch(window.SHOPIFY_BOT_DATA_URL)
    .then(res => res.json())
    .then(data => {
      BOT_DATA = data;
      console.log("✅ data.json loaded correctly in Shopify");
    })
    .catch(err => {
      console.error("❌ data.json fetch failed", err);
      BOT_DATA = { intentAnswers: {} };
    });
}

/* =========================
   NORMALIZE TEXT
========================= */
function normalize(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/* =========================
   GET BOT REPLY - COMPLETE INTENT MAPPING
========================= */
window.getBotReply = function (userInput) {
  console.log("\n=== QUERY ===");
  console.log("User:", userInput);
  
  if (!BOT_DATA || !BOT_DATA.intentAnswers) {
    return "Bot loading...";
  }

  const originalText = userInput.toLowerCase();
  const text = normalize(userInput);
  console.log("Normalized:", text);
  
  // 1. OFFENSIVE CONTENT FILTER
  const inappropriateWords = ["sex", "porn", "xxx", "nude", "fuck", "ass", "dick", "pussy"];
  for (const word of inappropriateWords) {
    if (originalText.includes(word)) {
      return "I'm here to help with GulmoharTree Ayurvedic products only. Please ask relevant questions.";
    }
  }
  
  // 2. EXACT PHRASE MATCHES
  const exactGreetings = {
    "hi": "greeting",
    "hello": "greeting",
    "hey": "greeting",
    "namaste": "greeting",
    "kaise ho": "greeting",
    "aap kaise hain": "greeting",
    "good morning": "greeting",
    "good afternoon": "greeting",
    "good evening": "greeting",
    
    "bye": "thank_you",
    "goodbye": "thank_you",
    "alvida": "thank_you",
    "thanks": "thank_you",
    "thank you": "thank_you",
    "dhanyavad": "thank_you",
    "shukriya": "thank_you"
  };
  
  for (const [phrase, intent] of Object.entries(exactGreetings)) {
    if (originalText === phrase.toLowerCase() || text === phrase) {
      console.log(`✅ Exact phrase: "${phrase}" -> ${intent}`);
      if (BOT_DATA.intentAnswers[intent]) {
        return BOT_DATA.intentAnswers[intent];
      }
    }
  }
  
  // 3. PRIORITY PHRASE MATCHING (Updated with all intents)
  const priorityPhrases = [
    // Product Information
    { pattern: "what is this", intent: "product_overview" },
    { pattern: "product details", intent: "product_overview" },
    { pattern: "yeh kya hai", intent: "product_overview" },
    
    // Pain Types
    { pattern: "arthritis", intent: "pain_type_suitability" },
    { pattern: "back pain", intent: "pain_type_suitability" },
    { pattern: "knee pain", intent: "pain_type_suitability" },
    { pattern: "joint pain", intent: "pain_type_suitability" },
    
    // Ingredients
    { pattern: "ingredients", intent: "ingredients_list" },
    { pattern: "whats inside", intent: "ingredients_list" },
    { pattern: "kya hai isme", intent: "ingredients_list" },
    { pattern: "herbs", intent: "ingredients_list" },
    
    // How it works
    { pattern: "how it works", intent: "how_it_works" },
    { pattern: "kaise kaam karta", intent: "how_it_works" },
    
    // Bottle Sizes
    { pattern: "bottle size", intent: "bottle_sizes" },
    { pattern: "what size", intent: "bottle_sizes" },
    { pattern: "kitne size", intent: "bottle_sizes" },
    { pattern: "available sizes", intent: "bottle_sizes" },
    
    // Pricing
    { pattern: "price", intent: "pricing" },
    { pattern: "cost", intent: "pricing" },
    { pattern: "kitne ka", intent: "pricing" },
    { pattern: "how much", intent: "pricing" },
    
    // Discounts
    { pattern: "discount", intent: "discounts_offers" },
    { pattern: "offer", intent: "discounts_offers" },
    { pattern: "coupon", intent: "discounts_offers" },
    
    // How to Use
    { pattern: "how to use", intent: "how_to_use" },
    { pattern: "kaise use", intent: "how_to_use" },
    { pattern: "apply", intent: "how_to_use" },
    { pattern: "massage", intent: "application_details" },
    
    // Results Timeline
    { pattern: "results timeline", intent: "results_timeline" },
    { pattern: "kitne din mein result", intent: "results_timeline" },
    { pattern: "how long to see", intent: "results_timeline" },
    
    // Effectiveness
    { pattern: "effective", intent: "effectiveness" },
    { pattern: "work karega", intent: "effectiveness" },
    { pattern: "kaam karega", intent: "effectiveness" },
    
    // Side Effects
    { pattern: "side effects", intent: "side_effects" },
    { pattern: "nuksan", intent: "side_effects" },
    { pattern: "safe", intent: "side_effects" },
    
    // Age Restrictions
    { pattern: "children", intent: "age_restrictions" },
    { pattern: "bachon", intent: "age_restrictions" },
    { pattern: "elderly", intent: "age_restrictions" },
    
    // Medical Conditions
    { pattern: "diabetes", intent: "medical_conditions" },
    { pattern: "blood pressure", intent: "medical_conditions" },
    { pattern: "bp", intent: "medical_conditions" },
    
    // Pregnancy
    { pattern: "pregnancy", intent: "pregnancy_breastfeeding" },
    { pattern: "breastfeeding", intent: "pregnancy_breastfeeding" },
    { pattern: "pregnant", intent: "pregnancy_breastfeeding" },
    
    // Authenticity
    { pattern: "authentic", intent: "authenticity_certification" },
    { pattern: "original", intent: "authenticity_certification" },
    { pattern: "certified", intent: "authenticity_certification" },
    
    // Doctor Recommended
    { pattern: "doctor", intent: "doctor_recommended" },
    { pattern: "recommended", intent: "doctor_recommended" },
    
    // Reviews
    { pattern: "reviews", intent: "reviews_testimonials" },
    { pattern: "ratings", intent: "reviews_testimonials" },
    { pattern: "testimonials", intent: "reviews_testimonials" },
    
    // Order Process
    { pattern: "order", intent: "checkout_process" },
    { pattern: "buy", intent: "checkout_process" },
    { pattern: "purchase", intent: "checkout_process" },
    { pattern: "place order", intent: "checkout_process" },
    { pattern: "how to order", intent: "checkout_process" },
    
    // Payment Options
    { pattern: "payment", intent: "payment_options" },
    { pattern: "cod", intent: "payment_options" },
    { pattern: "upi", intent: "payment_options" },
    { pattern: "card", intent: "payment_options" },
    
    // Payment Issues
    { pattern: "payment failed", intent: "payment_failed" },
    { pattern: "transaction failed", intent: "payment_failed" },
    
    // Invoice/GST
    { pattern: "invoice", intent: "invoice_gst" },
    { pattern: "bill", intent: "invoice_gst" },
    { pattern: "receipt", intent: "invoice_gst" },
    { pattern: "gst", intent: "invoice_gst" },
    
    // Delivery
    { pattern: "delivery time", intent: "delivery_time" },
    { pattern: "shipping time", intent: "delivery_time" },
    { pattern: "kitne din", intent: "delivery_time" },
    
    // Shipping Charges
    { pattern: "shipping charges", intent: "shipping_charges" },
    { pattern: "delivery charges", intent: "shipping_charges" },
    { pattern: "free shipping", intent: "shipping_charges" },
    
    // Track Order
    { pattern: "track", intent: "track_order" },
    { pattern: "tracking", intent: "track_order" },
    { pattern: "order status", intent: "track_order" },
    
    // Delivery Issues
    { pattern: "delivery issue", intent: "delivery_issues" },
    { pattern: "late delivery", intent: "delivery_issues" },
    { pattern: "wrong address", intent: "delivery_issues" },
    
    // Return Policy
    { pattern: "return policy", intent: "return_policy" },
    { pattern: "refund policy", intent: "return_policy" },
    { pattern: "return", intent: "return_policy" },
    { pattern: "refund", intent: "return_policy" },
    
    // Initiate Return
    { pattern: "initiate return", intent: "initiate_return" },
    { pattern: "start return", intent: "initiate_return" },
    { pattern: "how to return", intent: "initiate_return" },
    
    // Refund Timeline
    { pattern: "refund timeline", intent: "refund_timeline" },
    { pattern: "refund kitne din", intent: "refund_timeline" },
    { pattern: "paise kab aayenge", intent: "refund_timeline" },
    
    // Cancel Order
    { pattern: "cancel order", intent: "cancel_order" },
    { pattern: "cancel my order", intent: "cancel_order" },
    
    // Bulk Order
    { pattern: "bulk order", intent: "bulk_order" },
    { pattern: "wholesale", intent: "bulk_order" },
    { pattern: "business order", intent: "bulk_order" },
    
    // Product Comparison
    { pattern: "vs", intent: "product_comparison" },
    { pattern: "compare", intent: "product_comparison" },
    { pattern: "volini", intent: "product_comparison" },
    { pattern: "moov", intent: "product_comparison" },
    
    // Stock Availability
    { pattern: "stock", intent: "stock_availability" },
    { pattern: "available", intent: "stock_availability" },
    { pattern: "out of stock", intent: "stock_availability" },
    
    // Customer Care
    { pattern: "customer care", intent: "contact_customer_care" },
    { pattern: "customer support", intent: "contact_customer_care" },
    { pattern: "contact number", intent: "contact_customer_care" },
    { pattern: "phone number", intent: "contact_customer_care" },
    { pattern: "whatsapp number", intent: "contact_customer_care" },
    { pattern: "email", intent: "contact_customer_care" },
    { pattern: "contact us", intent: "contact_customer_care" },
    
    // Confused Help
    { pattern: "confused", intent: "confused_help" },
    { pattern: "help", intent: "confused_help" },
    { pattern: "samajh nahi", intent: "confused_help" },
    
    // Angry/Frustrated
    { pattern: "angry", intent: "angry_frustrated" },
    { pattern: "frustrated", intent: "angry_frustrated" },
    { pattern: "complaint", intent: "angry_frustrated" },
    { pattern: "gussa", intent: "angry_frustrated" }
  ];
  
  // Check priority phrases
  for (const { pattern, intent } of priorityPhrases) {
    if (text.includes(pattern)) {
      console.log(`✅ Priority phrase: "${pattern}" -> ${intent}`);
      if (BOT_DATA.intentAnswers[intent]) {
        return BOT_DATA.intentAnswers[intent];
      }
    }
  }
  
  // 4. QUESTION WORD HANDLING
  if (text.includes("what") || text.includes("which") || text.includes("kya") || 
      text.includes("how") || text.includes("when") || text.includes("where") || 
      text.includes("why")) {
    console.log("🔍 Question detected");
    
    // Map question words to intents
    const questionMap = [
      { words: ["price", "cost", "kitne ka"], intent: "pricing" },
      { words: ["size", "bottle", "ml"], intent: "bottle_sizes" },
      { words: ["delivery", "shipping", "kitne din"], intent: "delivery_time" },
      { words: ["ingredient", "herb", "composition"], intent: "ingredients_list" },
      { words: ["return", "refund", "exchange"], intent: "return_policy" },
      { words: ["use", "apply", "kaise use"], intent: "how_to_use" },
      { words: ["result", "time", "kitne din mein"], intent: "results_timeline" },
      { words: ["effective", "work", "kaam"], intent: "effectiveness" },
      { words: ["side effect", "nuksan", "safe"], intent: "side_effects" },
      { words: ["authentic", "original", "certified"], intent: "authenticity_certification" },
      { words: ["doctor", "recommend"], intent: "doctor_recommended" },
      { words: ["review", "rating", "feedback"], intent: "reviews_testimonials" },
      { words: ["order", "buy", "purchase"], intent: "checkout_process" },
      { words: ["payment", "pay", "cod"], intent: "payment_options" },
      { words: ["invoice", "bill", "receipt"], intent: "invoice_gst" },
      { words: ["track", "status", "kahan hai"], intent: "track_order" },
      { words: ["cancel", "stop"], intent: "cancel_order" },
      { words: ["bulk", "wholesale", "business"], intent: "bulk_order" },
      { words: ["compare", "vs", "difference"], intent: "product_comparison" },
      { words: ["stock", "available", "hai kya"], intent: "stock_availability" },
      { words: ["care", "support", "contact", "phone", "email"], intent: "contact_customer_care" }
    ];
    
    for (const { words, intent } of questionMap) {
      for (const word of words) {
        if (text.includes(word) && BOT_DATA.intentAnswers[intent]) {
          console.log(`✅ Question word match: "${word}" -> ${intent}`);
          return BOT_DATA.intentAnswers[intent];
        }
      }
    }
  }
  
  // 5. SINGLE WORD INTENT MAPPING (Comprehensive)
  const wordMap = {
    // Product Info
    "product": "product_overview",
    "overview": "product_overview",
    "information": "product_overview",
    
    // Pain Types
    "arthritis": "pain_type_suitability",
    "pain": "pain_type_suitability",
    "back": "pain_type_suitability",
    "knee": "pain_type_suitability",
    "joint": "pain_type_suitability",
    "muscle": "pain_type_suitability",
    "cramps": "pain_type_suitability",
    
    // Ingredients
    "ingredient": "ingredients_list",
    "herb": "ingredients_list",
    "composition": "ingredients_list",
    "formula": "ingredients_list",
    
    // How it works
    "works": "how_it_works",
    "mechanism": "how_it_works",
    "process": "how_it_works",
    
    // Bottle
    "size": "bottle_sizes",
    "bottle": "bottle_sizes",
    "ml": "bottle_sizes",
    "volume": "bottle_sizes",
    
    // Pricing
    "price": "pricing",
    "cost": "pricing",
    "rate": "pricing",
    "mrp": "pricing",
    
    // Discounts
    "discount": "discounts_offers",
    "offer": "discounts_offers",
    "coupon": "discounts_offers",
    "sale": "discounts_offers",
    
    // Usage
    "use": "how_to_use",
    "apply": "how_to_use",
    "application": "how_to_use",
    
    // Results
    "results": "results_timeline",
    "timeline": "results_timeline",
    "time": "results_timeline",
    
    // Effectiveness
    "effective": "effectiveness",
    "work": "effectiveness",
    "guarantee": "effectiveness",
    
    // Safety
    "safe": "side_effects",
    "side": "side_effects",
    "effect": "side_effects",
    "nuksan": "side_effects",
    
    // Age
    "age": "age_restrictions",
    "children": "age_restrictions",
    "elderly": "age_restrictions",
    "senior": "age_restrictions",
    
    // Medical
    "medical": "medical_conditions",
    "diabetes": "medical_conditions",
    "bp": "medical_conditions",
    "thyroid": "medical_conditions",
    
    // Pregnancy
    "pregnancy": "pregnancy_breastfeeding",
    "pregnant": "pregnancy_breastfeeding",
    "breastfeeding": "pregnancy_breastfeeding",
    
    // Authenticity
    "authentic": "authenticity_certification",
    "original": "authenticity_certification",
    "genuine": "authenticity_certification",
    "certified": "authenticity_certification",
    
    // Doctor
    "doctor": "doctor_recommended",
    "recommend": "doctor_recommended",
    "prescribe": "doctor_recommended",
    
    // Reviews
    "review": "reviews_testimonials",
    "rating": "reviews_testimonials",
    "testimonial": "reviews_testimonials",
    "feedback": "reviews_testimonials",
    
    // Order Process
    "order": "checkout_process",
    "buy": "checkout_process",
    "purchase": "checkout_process",
    "checkout": "checkout_process",
    
    // Payment
    "payment": "payment_options",
    "pay": "payment_options",
    "cod": "payment_options",
    "upi": "payment_options",
    "card": "payment_options",
    "emi": "payment_options",
    
    // Invoice
    "invoice": "invoice_gst",
    "bill": "invoice_gst",
    "receipt": "invoice_gst",
    "gst": "invoice_gst",
    
    // Delivery
    "delivery": "delivery_time",
    "shipping": "delivery_time",
    "dispatch": "delivery_time",
    
    // Shipping Charges
    "charges": "shipping_charges",
    "fees": "shipping_charges",
    
    // Track
    "track": "track_order",
    "tracking": "track_order",
    "status": "track_order",
    
    // Return/Refund
    "return": "return_policy",
    "refund": "refund_timeline",
    "exchange": "return_policy",
    
    // Cancel
    "cancel": "cancel_order",
    "cancellation": "cancel_order",
    
    // Bulk
    "bulk": "bulk_order",
    "wholesale": "bulk_order",
    "business": "bulk_order",
    
    // Comparison
    "compare": "product_comparison",
    "comparison": "product_comparison",
    "difference": "product_comparison",
    
    // Stock
    "stock": "stock_availability",
    "available": "stock_availability",
    
    // Customer Care
    "care": "contact_customer_care",
    "support": "contact_customer_care",
    "contact": "contact_customer_care",
    "phone": "contact_customer_care",
    "whatsapp": "contact_customer_care",
    "email": "contact_customer_care",
    "number": "contact_customer_care",
    "helpline": "contact_customer_care",
    "service": "contact_customer_care",
    
    // Emotional States
    "confused": "confused_help",
    "help": "confused_help",
    "angry": "angry_frustrated",
    "frustrated": "angry_frustrated",
    "complaint": "angry_frustrated"
  };
  
  // Check single words
  const userWords = text.split(" ");
  for (const word of userWords) {
    if (word.length < 3) continue;
    
    const skipWords = ["how", "what", "when", "where", "why", "which", "kaise", "kya"];
    if (skipWords.includes(word)) continue;
    
    if (wordMap[word] && BOT_DATA.intentAnswers[wordMap[word]]) {
      console.log(`✅ Word match: "${word}" -> ${wordMap[word]}`);
      return BOT_DATA.intentAnswers[wordMap[word]];
    }
  }
  
  // 6. FALLBACKS
  console.log("🤔 No match found");
  
  // Check fallback patterns
  const fallbacks = BOT_DATA.fallbacks || [];
  for (const fallback of fallbacks) {
    for (const pattern of fallback.queryPatterns) {
      if (text.includes(pattern.toLowerCase())) {
        console.log(`🔁 Fallback match: "${pattern}"`);
        return fallback.response;
      }
    }
  }
  
  // Hindi greeting fallback
  if (text.includes("kaise") || text.includes("aap")) {
    return BOT_DATA.intentAnswers.greeting || "Namaste! Main theek hoon. Aapka swagat hai GulmoharTree mein!";
  }
  
  // Off-topic fallback
  const offTopicWords = ["weather", "cricket", "movie", "politics", "news", "joke", "food"];
  for (const word of offTopicWords) {
    if (text.includes(word)) {
      return BOT_DATA.intentAnswers.off_topic || "I'm specially trained to help with GulmoharTree products and Ayurvedic pain relief. How can I assist you with our pain relief oil today?";
    }
  }
  
  // Default helpful response
  return `Namaste! I help with GulmoharTree Ayurvedic Pain Relief Oil.

Quick help:
• Type "price" for pricing
• Type "order" for buying process  
• Type "size" for bottle sizes
• Type "delivery" for shipping info
• Type "return" for refund policy
• Type "use" for application guide
• Type "contact" for customer support

What would you like to know?`;
};